import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/layout.tsx");
